module.exports = __webpack_public_path__ + "media/img/filter-icon-cfe202813d1a5f074be41a2caabb466f.png";